import MainMenuContainer from "../../MainMenuContainer";
import styled from "styled-components";
import { Logo } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const LogoStyled = styled(Logo)`
  position: relative;
`;

export const ImageStyled = styled.img`
  position: absolute;
  transform: translate(-50%, -50%);
  margin-top: 1rem;
  width: 11vw;
`;

export const LogoWrapperStyled = styled.div`
  position: absolute;
  top: 3rem;
  ${props =>
    `${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right"} :
         ${!props.brandName ? "3rem" : props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT ? "15rem" : "25rem"} 
    }`}
  z-index: 99999;
`;

export const LogoShadeStyled = styled.div`

    position : absolute;
    z-index: 9999;
    top:0;
    ${props =>
      `${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left"} : 64.3%
  }`}

    ${props =>
      `${
        props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT
          ? "transform: rotate(-90deg);"
          : "transform: rotate(0deg)"
      }
    }`}

    ${props =>
      `${
        props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT
          ? "-webkit-transform: rotate(-90deg);"
          : "-webkit-transform: rotate(0deg)"
      }
    }`}
   
    width: 38.125rem;
    height: 36.1875rem;
    background: no-repeat;
    pointer-events: none;
    background-image: url("data:image/svg+xml,%3Csvg  viewBox='0 0 610 579' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3ERectangle%3C/title%3E%3Cdefs%3E%3CradialGradient cx='114.830639%25' cy='-30.7116749%25' fx='114.830639%25' fy='-30.7116749%25' r='91.8064413%25' gradientTransform='translate(1.148306 -0.307117) scale(0.562639 1.000000) rotate(132.658411) translate(-1.148306 0.307117)' id='radialGradient-1'%3E%3Cstop stop-color='%23000000' offset='0%25'%3E%3C/stop%3E%3Cstop stop-color='%23000000' stop-opacity='0' offset='100%25'%3E%3C/stop%3E%3C/radialGradient%3E%3C/defs%3E%3Cg id='3.-Logged-in-/out-%7C-Channels' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='1B.1.3-Activated' transform='translate(-1310.000000  0.000000)' fill='url(%23radialGradient-1)'%3E%3Cg id='Group-2' transform='translate(116.000000  0.000000)'%3E%3Crect id='Rectangle' x='0' y='0' width='1804' height='1015'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  `;
